<!--
 * @Descripttion: 新签月嫂订单详情
 * @version: 1.0.0
 * @Author: 19185247 刘云飞
 * @Date: 2020-09-30
 * @LastEditors: Please set LastEditors
-->
<template lang="html">
  <div class="order-detail">
    <empty v-if="!order.orderId" v-show="!firstFetch" :text="errText"></empty>
    <div
      v-else
      class="order-detail-con"
      :class="{
        'order-bg':
          order.refundState == 10 &&
          (order.orderState === 30 || order.orderState === 40)
      }"
    >
      <div>
        <status
          :order="order"
          :groupTime="groupDetail.groupEndTime"
          :synthesisStateDesc="orderSynthesisStateDesc"
        ></status>
        <!--月嫂已上户，露出核销模块-->
        <signatures
          style="display: none"
          v-if="isShowSignatrueModule"
          :codeList="order.barcodeList"
          :channelType="order.channelType"
          :groupStaus="groupDetail.smallGroupStatus"
          @barCode="barCode"
          ref="Signatures"
        ></signatures>
        <ServiceInfo
          :worker="worker"
          :order="order"
          :isVirtual="isVirtual"
          v-if="!hideServeCompsYunChanJiaTHG"
        />

        <ParentingConsultant
          v-if="isShowConsultant"
          :consultant="order.inviteInfo"
        />

        <price
          :product="product"
          :orderStatus="order.orderState"
          :stateDesc="orderSynthesisStateDesc"
          :order="order"
        ></price>

        <infoList
          :order="order"
          :stateDesc="orderSynthesisStateDesc"
          :state="state"
          :remark="order.remark"
        ></infoList>
      </div>
      <!--TODO 底部增加“客服”按钮，对接商客合一IM，点击进入在线咨询页面，不自动发送文案，具体见商客合一客服需求（商客合一IM实现前不加）-->
      <actionbar v-if="btnList.length > 0">
        <template v-for="btn in btnList">
          <button
            class="btns"
            :class="btn.styleClass"
            @click="operation(btn.actionType)"
            slot="buttons"
          >
            {{ btn.txt }}
          </button>
        </template>
      </actionbar>

      <actionSheet :viewName="viewName" :params="params"></actionSheet>
      <!-- 不要删除 iPhone X 底部高度-->
      <div class="menu_wkBox_back_box"></div>
      <div id="confirm_delete_order_dialog">
        <div class="item-cells dialog-useCode">
          <p class="summary">确认删除该订单？</p>
        </div>
      </div>
    </div>
    <loading :visible="orderLoadingVisible"></loading>
    <!-- <mt-popup v-model="confirmVisible"> -->
    <ConfirmDialog
      :serviceTime="applyHouseHoldTime"
      :refundState="order.refundState"
      :order="order"
      ref="confirmDialog"
    >
    </ConfirmDialog>
    <ServiceDialog
      ref="serviceDialog"
      :order="order"
      :worker="worker"
      :type="businessType"
      :isVirtual="isVirtual"
    >
    </ServiceDialog>
    <NewServiceLogDialog
      ref="newServiceLogDialog"
      @showDialogNewServiceLogAndRefresh="showDialogNewServiceLogAndRefresh"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import status from '@/components/newOrder/order-status.vue'
import signatures from '@/components/newOrder/signature.vue'
// import product from '@/components/newOrder/product.vue'
import serve from '@/components/newOrder/serve.vue'
import price from '@/components/newOrder/price.vue'
import infoList from '@/components/newOrder/infoList.vue'
import actionbar from '@/components/newOrder/actionbar.vue'
import users from '@/components/newOrder/user.vue'
import ServiceInfo from '@/components/newOrder/yuesao/serviceInfo'
import ParentingConsultant from '@/components/newOrder/yuesao/parentingConsultant'
import actionSheet from '@/components/actionSheet/index.vue'
import TipApply from '@/components/newOrder/yuesao/tip4HomeApplycation'
import empty from '@/components/common/empty'
import { Msgbox } from 'kf-component-vue'
import loading from '@/components/common/loading/custome-loading'
import { pushHref, pushNrNs } from '@/plugins/jump'
import { B_ORDER_YS, getOrderSynthesisStateDesc } from '@/business'
import { getAdress, getServiceTime } from './lib'
import { getButtonList, serviceCompleted } from './getButtonLisYuesao'
import im from '@/store/actions/im'
import log from '@/store/actions/log'
import { fetchConfirm2home, handleOrderSas } from '@/service/order'
import { Popup } from 'mint-ui'
import ConfirmDialog from './confirm-dialog'
import ServiceDialog from './service-dialog'
import NewServiceLogDialog from './dialog-service-log'
// 码状态barcodeState 0:待使用，1 已核销，3过期
import mixProm from '@/mixin/mixProm'
import {
  ORDER_MONEY_PAY_TYPE,
  OrderDetailActionType_ENUM,
  E_SKUTAG
} from '@/config'
import { setOrderId } from '@/business/order/confirmParams'
import { Indicator } from 'mint-ui'

export default {
  mixins: [mixProm],
  inject: {
    reload: {},
    detailTrackParams: {
      default: null
    }
  },
  data() {
    return {
      firstFetch: true,
      orderCode: '',
      orderState: [
        '',
        '待支付',
        '待消费',
        '待评价',
        '已完成',
        '已取消',
        '退款中',
        '已退款'
      ],
      errText: '订单不存在',
      price: 0,
      params: {},
      groupDetail: {},
      orderLoadingVisible: false,
      confirmVisible: false,
      businessType: 'refund'
    }
  },
  async created() {
    this.orderLoadingVisible = false
    this.$$title('订单详情')
    try {
      this.orderCode = this.$route.params.orderCode
      const { uid, skey } = await this.$$ensureLogin()
      const res = await this.$store.dispatch('getOrderDetail', {
        uid,
        skey,
        orderCode: this.orderCode
      })
      if (res.code * 1 === 4) {
        this.$$login()
        return
      }
      const { channelType, groupId } = this.order
      channelType === 4 && groupId && this.getGroupDetail(uid, groupId)
      this.firstFetch = false
      if (this.order.coupon_code && this.order.coupon_code !== '') {
        this.$store.commit('setSelectedCoupon', {
          Code: this.order.coupon_code,
          Price: this.order.coupon_amt,
          Name: this.order.coupon_name
        })
      }

      this.$$loading(false)
      this.$store.dispatch('getReasons')
      // this.address();
    } catch (e) {
      this.firstFetch = false
      this.$$loading(false)
      if (e.message === '4') {
        this.$$login()
      } else {
        this.errText = '查询订单异常'
      }
    }
    this.detailTrackParams &&
      this.$$newTrackView({
        ...this.detailTrackParams,
        pageParam: {
          skutype: this.order.skuSecType
        }
      })
  },
  mounted() {
    this.$$allowRefreshOrShare(true, false)
  },
  computed: {
    ...mapState(['viewName', 'order']),
    orderSynthesisStateDesc() {
      return getOrderSynthesisStateDesc(this.order)
    },
    product() {
      return {
        endPayPrice: this.order.payPeriodInfo
          ? this.order.payPeriodInfo.endPayOrder.endPayPrice
          : 0,
        wholeDiscount: this.order.discountAmt,
        preOrderPrice: this.order.payPeriodInfo
          ? this.order.payPeriodInfo.prePayOrder.preOrderPrice
          : 0,
        endOrderPrice: this.order.payPeriodInfo
          ? this.order.payPeriodInfo.endPayOrder.endOrderPrice
          : 0,
        Pic: this.order.commdtyImage,
        businessName: this.order.businessName,
        Title: this.order.spuName,
        Sku: this.order.skuName,
        Id: this.order.spuId,
        refund_supply: this.order.allow_return,
        Price: this.order.orderPrice,
        TotalPrice: this.order.orderPrice,
        ActualPrice: this.order.payPrice,
        num: this.order.num,
        refund_anytime: this.order.isAnyTimeRefund,
        refund_overdue: this.order.isExpireRefund,
        trade_type: this.order.vorder_type,
        isPosPay: this.order.isPosPay,
        userType: this.order.userType,
        serviceCode: this.order.serviceCode,
        spuId: this.order.spuId,
        discountAmt: this.order.discountAmt
      }
    },
    worker() {
      const address = getAdress(this.order)
      const ext =
        this.order.extInfo && this.order.extInfo[0]
          ? this.order.extInfo[0].labelValue
          : ''

      return {
        headImage: this.order.headImage,
        userType: this.order.userType,
        address:
          address.province + address.city + address.district + address.address,
        workerCode: this.order.home_worker,
        workerName: this.order.workerName,
        mobile:
          this.order.level4CategoryId === '10111019'
            ? ''
            : this.order.workerMobile,
        uid: this.order.workerUid,
        storeName: this.order.workerStoreName,
        userName: address.name || '',
        contact: address.mobile || '',
        dateTime: ext,
        regionIds: address.regionid || '',
        servicedTimes: this.order.servicedTimes,
        serviceCode: this.order.serviceCode,
        spuId: this.order.spuId,
        serviceTime: getServiceTime(this.order)
      }
    },
    /**
     * 是否为虚拟月嫂
     */
    isVirtual() {
      const { workerType } = this.order
      return B_ORDER_YS.isVirtual(workerType)
    },
    /**
     * 虚拟月嫂无育儿顾问
     * 商家代客下单无育儿顾问
     */
    isShowConsultant() {
      const { serviceCode, extInfo = [] } = this.order
      if (extInfo.find(x => x.labelKey === 'helpOrderId')) {
        if (serviceCode && serviceCode.indexOf('w') !== -1) return false
      }
      return !this.isVirtual
    },
    state() {
      return this.order.orderState // 10.待支付20.待使用30.待评价40.已完成50.已取消(可选项)
    },
    applyHouseHoldTime() {
      return B_ORDER_YS.getBarCodeInfo(this.order).applyHouseHoldTime
    },
    canRefund() {
      // 所有码都未使用才可以申请退单，0元订单不支持申请退单  商品必须是随时退才露出申请退款
      const codes = this.order.barcodeList || []
      let canUseCodes = codes
      if (codes && codes.length > 0) {
        canUseCodes = codes.filter(v => v.barcodeState === 0)
      }
      const product_state = this.order.isAnyTimeRefund === 1 // 随时退
      return (
        (this.order.refundState === 10 || this.order.refundState === 40) &&
        product_state &&
        canUseCodes.length === codes.length &&
        this.order.payPrice !== 0
      ) // 0元不退
    },
    isShowSignatrueModule() {
      const { orderState } = this.order
      const workState = B_ORDER_YS.getWorkState(this.order)
      return B_ORDER_YS.isInService(orderState, workState)
    },
    isShowApplyTips() {
      const { orderState } = this.order
      const workState = B_ORDER_YS.getWorkState(this.order)
      return B_ORDER_YS.isHomeApplied(orderState, workState)
    },
    btnList() {
      return getButtonList(this)
    },
    isPendingPayment() {
      return B_ORDER_YS.isPendingPayment(this.order.orderState)
    },
    // 2023-08-02 孕产加特惠馆项目
    // 孕产特惠馆自营商家产品不需要服务人员、服务门店、服务时间
    // isNeedServiceMan: 1 需要 / 0 不需要
    hideServeCompsYunChanJiaTHG() {
      const { isNeedServiceMan, skuTag } = this.order
      return (
        [E_SKUTAG.SELFSTORE, E_SKUTAG.SELFHOME].includes(skuTag) &&
        isNeedServiceMan === 0
      )
    }
  },
  methods: {
    ...mapMutations(['showActionSheet', 'setActionHeader', 'changeView']),
    barCode(v) {
      this.orderLoadingVisible = v
    },
    evaluate() {
      pushNrNs({
        // 新写评价入口
        name: 'evaluate',
        query: {
          orderCode: this.order.orderId,
          ht: 'add'
        }
      })
      // location.href = `/v/order/${this.order.orderId}/comment/add?cmd=share&sharetype=0&refresh=no`  // 原评价入口
    },
    toLookEvaluate() {
      pushHref({
        // 新查看评价入口
        name: 'evaluate',
        query: {
          commentId: this.order.commentId,
          orderCode: this.order.orderId,
          ht: 'look'
        }
      })
    },
    cancelOrder() {
      this.changeView('cancelReason')
      this.setActionHeader({
        title: '取消原因'
      })
      this.showActionSheet()
    },
    async confirmDeleteOrder() {
      Msgbox({
        title: '确认删除该订单？',
        message: '',
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'confirm',
        action: async msgbox => {
          this.orderLoadingVisible = true
          const { uid, skey } = await this.$$ensureLogin()
          const res = await this.$store.dispatch('deleteOrder', {
            uid,
            skey,
            vorder_id: this.order.orderId
          })
          if (res.code === '1') {
            this.orderLoadingVisible = false
            this.$$toast('删除成功')
            setTimeout(() => {
              location.href = `//life.cekid.com/v/user/order?cmd=share&sharetype=0`
            }, 1000)
          } else if (res.code === '4') {
            this.orderLoadingVisible = false
            this.$$login()
          } else {
            this.$$toast('删除失败')
            this.orderLoadingVisible = false
          }
        },
        cancel: msgbox => {}
      })
    },
    //订单详情月嫂下单
    payOrder() {
      const { payPeriodInfo = {}, orderId = '' } = this.order
      const { prePayOrder = {}, endPayOrder = {} } = payPeriodInfo
      const { endOrderId = '' } = endPayOrder
      const { preOrderId = '' } = prePayOrder
      // 因为付款成功之后需要使用母订单订单号查看订单详情，顾存在localStorage里边
      setOrderId(orderId)
      let orderCode = ''
      if (this.PayType == ORDER_MONEY_PAY_TYPE.prePayOrder) {
        //2
        orderCode = preOrderId
      } else if (this.PayType === ORDER_MONEY_PAY_TYPE.endPayOrder) {
        //3
        orderCode = endOrderId
      } else {
        orderCode = orderId
      }
      if (this.order.isPosPay) {
        location.href = `/v/order/payment/${orderCode}?cmd=share&sharetype=0&refresh=no`
      } else {
        const url = `${this.$$hostname(
          'cashier'
        )}/query/${orderCode}?partnerid=3004&platformid=2&dealcode=${orderCode}`
        location.href = `//app.czj100.com/webridge.html?url=${encodeURIComponent(
          url
        )}&uid=${this.$$cookie('uid')}&skey=${this.$$cookie('skey')}`
      }
    },
    returnOrder() {
      this.changeView('refundReason')
      this.setActionHeader({
        title: '退单原因'
      })
      this.params = {
        payType: this.order.payType,
        partnerType: this.order.partnerType
      }
      this.showActionSheet()
    },
    kefu() {
      if (this.state === 1) {
        // 待支付
        this.$$kefu('XN0202', 'XN0102')
      } else if (this.state === 5) {
        // 取消订单
        this.$$kefu('XN0204', 'XN0104')
      } else if (this.state > 5) {
        // 退款
        this.$$kefu('XN0205', 'XN0105')
      } else {
        this.$$kefu('XN0203', 'XN0103')
        if (this.state === 2) {
        } else if (this.state === 3) {
        }
      }
    },
    showGroupDetail() {
      location.href = `/v/order/group/${this.order.groupId}?cmd=share&sharetype=0&refresh=no`
    },
    async getGroupDetail(uid, groupId) {
      const res = await this.$store.dispatch('getGroupDetail', {
        uid,
        groupId
      })
      if (
        res.code === '1' &&
        res.data &&
        res.data.detailVo &&
        Object.keys(res.data.detailVo).length
      ) {
        this.groupDetail = res.data.detailVo
        // test
        // this.groupDetail.groupEndTime = 1565919198000
        // this.groupDetail.smallGroupStatus = 1
      }
    },
    operation(actionType) {
      switch (actionType) {
        case OrderDetailActionType_ENUM.TO_CANCEL_ORDER: {
          this.cancelOrder()
          break
        }
        case OrderDetailActionType_ENUM.TO_PAY:
        case OrderDetailActionType_ENUM.TO_PAY_PRE:
        case OrderDetailActionType_ENUM.TO_PAY_REST: {
          this.payOrder()
          break
        }
        // case E_ACTIONS.refuse2Home:
        //   this.refuse2Home()
        //   break

        case OrderDetailActionType_ENUM.TO_CONFIRM_YUESAO_DOOR2DOOR:
          this.confirm2Home()
          break
        case OrderDetailActionType_ENUM.TO_READ_NEW_YUESAO_LOG:
          this.goToReadNewServiceLog()
          break
        case OrderDetailActionType_ENUM.TO_CONFIRM_SERVICE_COMPLETED:
          if (serviceCompleted(this.order)) {
            this.complite()
          } else {
            Msgbox({
              title: '当前月嫂在服务中，是否确认提前完成该订单？',
              message: '',
              showCancelButton: true,
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'confirm',
              action: msgbox => {
                this.complite()
              },
              cancel: msgbox => {}
            })
          }
          break
        case OrderDetailActionType_ENUM.TO_COMMENT:
          this.evaluate()
          break
        case OrderDetailActionType_ENUM.TO_LOOK_COMMENTS:
          this.toLookEvaluate()
          break
        case OrderDetailActionType_ENUM.TO_APPLY_SERVICE_AFTER_SALE_YUESAO:
          this.applyAfterService()
          break
        case OrderDetailActionType_ENUM.TO_APPLY_REFUND:
          this.applyRefund()
          break
        case OrderDetailActionType_ENUM.TO_CANCEL_APPLY_REFUND:
          this.cancelRefund()
          break
        case OrderDetailActionType_ENUM.TO_CANCEL_SERVICE_AFTER_SALE_YUESAO:
          this.cancelAfterService()
          break
        case OrderDetailActionType_ENUM.TO_DEL_ORDER:
          this.deleteOrderMsgBox()
          break
        default:
          break
      }
    },
    showDialogNewServiceLogAndRefresh() {
      this.$refs.newServiceLogDialog.open() // 弹框关闭时刷新
    },
    // 申请售后
    applyAfterService() {
      this.businessType = 'service'
      console.log('applyAfterService')
      this.$refs.serviceDialog.open()
    },
    // 申请退款
    applyRefund() {
      this.businessType = 'refund'
      this.$refs.serviceDialog.open()
    },
    cancelAfterService() {
      // export async function handleOrderSas(orderId, source, state) {
      //   // orderId 订单号                                   必传
      //   // source 类型   0 售后 1 退款                        必传
      //   // state 状态    0 申请 1 撤销                     必传
      const title = '撤销售后申请'
      const message = '取消后，本次售后申请将关闭，确定继续吗'
      const { orderId = '' } = this.order
      const source = 0,
        state = 1
      this.cancelMsgBox(title, message, orderId, source, state)
    },
    cancelRefund() {
      // 撤销退款
      console.log('撤销退款')
      // export async function handleOrderSas(orderId, source, state) {
      //   // orderId 订单号                                   必传
      //   // source 类型 0 售后 1 退款                        必传
      //   // state 状态    0 申请 1 撤销                     必传
      const title = '撤销退款申请'
      const message = '取消后，本次退款申请将关闭，确定继续吗'
      const { orderId = '' } = this.order
      const source = 1,
        state = 1
      this.cancelMsgBox(title, message, orderId, source, state)
    },
    cancelMsgBox(title, message, orderId, source, state) {
      Msgbox({
        title: title,
        message: message,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '我再想想',
        backgroundColor: 'rgba(0,0,0,.6)',
        type: 'confirm',
        action: msgbox => {
          this.$$loading(true)
          handleOrderSas(orderId, source, state).then(flag => {
            const str = `操作${flag ? '成功' : '失败'}`
            this.$$toast(str)
            // 更新页面
            this.reload()
          })
        },
        cancel: msgbox => {}
      })
    },
    confirm2Home() {
      this.$refs.confirmDialog.open()
    },
    goToReadNewServiceLog() {
      location.href = `/v/yuesao-serve/log-detail-user?kwtarget=blank`
    },
    complite() {
      // 核销
      Msgbox({
        title: '确认服务完成',
        message:
          '<p style="text-align:left"><b>提示：</b>确认服务完成，即表明您同意本平台向商家支付全额款项，并且后续产生的一切纠纷及/或损失均由您自行承担，与本平台无关</p>',
        showCancelButton: true,
        confirmButtonText: '确认完成',
        cancelButtonText: '取消',
        backgroundColor: 'rgba(0,0,0,.6)',
        type: 'confirm',
        action: msgbox => {
          console.log('确认服务完成')
          const s = this.$refs['Signatures']
          console.log(s)
          s.postCode(s.showingCode.barcode)
        },
        cancel: msgbox => {}
      })
    },
    deleteOrderMsgBox() {
      Msgbox({
        title: '删除订单',
        message: '确认删除？',
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        confirmButtonClass: 'comment-confirm',
        type: 'confirm',
        action: msgbox => {
          this.deleteOrder()
        },
        cancel: msgbox => {}
      })
    },
    async deleteOrder() {
      const { uid, skey } = await this.$$ensureLogin()
      const { orderId } = this.order
      Indicator.open()
      const res = await this.$store.dispatch('deleteOrder', {
        uid,
        skey,
        orderId
      })
      Indicator.close()
      if (+res.code === 1) {
        this.$$toast('删除成功')
        // 更新列表
        BUS.EMIT_E_PASS_INDEX_4_DEL_ITEM(this.index)
        //TODO goback
        // setTimeout(() => {
        //     location.href = `//life.cekid.com/v/user/order?cmd=share&sharetype=0`
        // }, 1000)
        this.$router.go(-1)
      } else if (res.code === '4') {
        this.$$login()
      } else {
        this.$$toast('抱歉，系统异常')
      }
    }
  },
  components: {
    // product,
    infoList,
    serve,
    price,
    signatures,
    actionbar,
    status,
    actionSheet,
    empty,
    users,
    Msgbox,
    loading,
    ServiceInfo,
    ParentingConsultant,
    TipApply,
    [Popup.name]: Popup,
    ConfirmDialog,
    ServiceDialog,
    NewServiceLogDialog
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.order-detail {
  min-height: 100%;
  padding-bottom: rem(119px);
}

.order-detail-con {
  background-image: linear-gradient(122deg, #ff5900 0%, #ff8800 100%);
  background-repeat: no-repeat;
  //   background: url('../../assets/images/order/order-bg.png') no-repeat;
  //   border-radius: 0 0 16px 16px;
  background-size: 100% rem(268px);
}

.order-bg {
  background-size: 100% rem(224px);
}

#confirm_delete_order_dialog {
  display: none;
}
.confirm-content {
  width: rem(560px);
  height: rem(520px);
  background: #ffffff;
  border-radius: rem(28px);
  text-align: center;
  padding-top: rem(40px);
  .title {
    font-size: rem(32px);
    color: #262626;
    text-align: center;
  }
  .sub-title {
    margin-top: rem(8px);
    font-size: rem(26px);
    color: #4d4d4d;
    text-align: center;
  }
  .confirm-btn {
    height: rem(87px);
    line-height: rem(87px);
    font-size: rem(32px);
    font-size: 700;
    color: #ff397e;
  }
  .cancel-btn {
    height: rem(87px);
    line-height: rem(87px);
    font-size: rem(32px);
    color: #ff397e;
  }
}
</style>
